import { ButtonWithLoading } from '@e3dc-react/shell/Elements/Buttons'
import { useSnackbar } from '@e3dc-react/shell/Hooks/Snackbar'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import React from 'react'
import { useGeneratePartnerNumber } from '../hooks/use-generate-partner-number'
import { useFormikContext } from 'formik'

interface GeneratePartnerNumberButtonProps {
  companyId: number
  isDisabled?: boolean
  fullWidth?: boolean
}

/**
 * Button to generate a partner number for a company.
 * Will only be visible when the company does not have a partner number yet.
 */
const GeneratePartnerNumberButton: React.FC<GeneratePartnerNumberButtonProps> = ({ companyId, isDisabled, fullWidth }) => {
  const { t } = useCustomTranslation()
  const { setFieldValue } = useFormikContext()

  const { enqueueSuccessStack, enqueueErrorStack } = useSnackbar()
  const { mutate: generatePartnerNumber, isPending: isPartnerNumberLoading } = useGeneratePartnerNumber({
    onSuccess: data => {
      setFieldValue('partnerNumber', data ? data.toString() : '')
      enqueueSuccessStack(t('service-dashboard.company.generate-partner-number.success'))
    },
    onError: () => {
      console.error('Could not generate partner number')
      enqueueErrorStack(t('service-dashboard.company.generate-partner-number.error.create'))
    },
  })

  const onClick = (): void => {
    generatePartnerNumber({ id: companyId })
  }

  return (
    <ButtonWithLoading
      variant="outlined"
      size="large"
      color="primary"
      disabled={isDisabled}
      isLoading={isPartnerNumberLoading}
      label={t('service-dashboard.company.generate-partner-number.button')}
      onClick={onClick}
      fullWidth={fullWidth}
    />
  )
}

export default GeneratePartnerNumberButton
